import { PAYMENT_STATUS } from './constants'

export default {
  statuses: Object.entries(PAYMENT_STATUS).map(([key, value]) => ({
    id: key,
    name: value.title
  })),

  projectSystems: [],
  systemTemplates: []
}
